__turbopack_context__.v({
  "badge": "NewsCategoryBadge-module-scss-module__QYVgYG__badge",
});
